
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("2ZkUh", function(module, exports) {

var $ccWUN = parcelRequire("ccWUN");


var $gFF2G = parcelRequire("gFF2G");


var $42omo = parcelRequire("42omo");


var $inPa6 = parcelRequire("inPa6");


var $cbc8g = parcelRequire("cbc8g");


var $irVI7 = parcelRequire("irVI7");


var $gfIPU = parcelRequire("gfIPU");

var $ln0hx = parcelRequire("ln0hx");

var $1eaCJ = parcelRequire("1eaCJ");

var $1kHsc = parcelRequire("1kHsc");


var $b3j2Y = parcelRequire("b3j2Y");


var $3IBnw = parcelRequire("3IBnw");


var $4PPzL = parcelRequire("4PPzL");


var $kpLJY = parcelRequire("kpLJY");


var $jmjWc = parcelRequire("jmjWc");


var $jMyy4 = parcelRequire("jMyy4");


var $12UWa = parcelRequire("12UWa");


var $aqBZ0 = parcelRequire("aqBZ0");


const $cd458192e783a00b$var$LazyUnarchivePagesLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "4vFoR",
    name: "LazyUnarchivePagesLoader",
    loader: async ()=>(await (parcelRequire("8BLp4"))).UnarchivePagesLoader
});

const $cd458192e783a00b$var$LazyArchivedPageBannerContent = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "fisHC",
    name: "LazyArchivedPageBannerContent",
    loader: async ()=>(await (parcelRequire("VfvF4"))).ArchivedPageBannerContent
});
const $cd458192e783a00b$var$ArchivedPageBannerComponent = ({ contentId: contentId, marginStyle: marginStyle = 'bottom' })=>{
    // We need two queries here: one to see if the content is archived or not, and the second to get
    // the archive note info if the content is archived. We MUST NOT do the second query for the
    // archive note info when the content is NOT archived because that second query will fail!
    //
    // And to properly handle Experience Tracking when using "cache-and-network" fetch then both
    // queries have to be in the same component because if you break the two queries into separate
    // nested components (as was done in an early version of this code), then the inner component is
    // likely to get unmounted when the query goes back to `loading` state on "network" part of a
    // cached fetch. The inner component loses any state info on the remount and can't remember if it
    // has sent the Experience Tracking events.  So it is simpler to have one single component with
    // both queries,
    const { error: statusError, data: statusData, refetch: statusRefetch } = (0, $jMyy4.useQueryInterop)((0, $gFF2G.default), {
        variables: {
            contentId: contentId
        },
        fetchPolicy: 'cache-and-network',
        __callerPackage__: "@confluence/archive-pages"
    });
    const contentStatus = statusData?.content?.nodes?.[0]?.status;
    const isContentArchived = contentStatus === (0, $aqBZ0.CONTENT_STATUS_ARCHIVED);
    // Note that when the user changes to a different page/content item, this component remains
    // mounted and will fetch the data for the new page, but the old "statusData" is still
    // available while the new data is being fetched. So the new data isn't really ready until
    // we see that the data has the correct contentId in it.
    const isStatusDataAvailable = contentStatus && statusData?.content?.nodes?.[0]?.id === contentId;
    // If the content is not archived, then we MUST NOT do the second query for the archive note
    // info because that query will fail!
    const { error: noteDataError, data: noteData } = (0, $jMyy4.useQueryInterop)((0, $ccWUN.default), {
        variables: {
            contentId: contentId
        },
        skip: !isContentArchived,
        fetchPolicy: 'cache-and-network',
        __callerPackage__: "@confluence/archive-pages"
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $inPa6.useAnalyticsEvents)();
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    // We need to keep the success atrributes object reference constant, as creating and assigning a
    // whole new object on every render pass will cause ExperienceSuccess's useEffect() to think
    // something has changed and it will fire the "success" event again. But if we keep the same
    // object across renders and just set the "archivedPageBannerShown" value, then ExperienceSuccess
    // sees no change there and will only fire again if something else has changed.
    const successAttributes = (0, $42omo.useMemo)(()=>({
            archivedPageBannerShown: false
        }), []);
    const getUnarchiveDialogOpener = (0, $42omo.useCallback)((dialogs)=>()=>{
            (0, $12UWa.fireUIClickEvent)({
                createAnalyticsEvent: createAnalyticsEvent,
                actionSubject: 'restoreButton',
                actionSubjectId: contentId,
                source: (0, $aqBZ0.ARCHIVED_PAGE_BANNER_ANALYTICS_SOURCE)
            });
            experienceTracker.start({
                name: (0, $irVI7.RESTORE_PAGES_EXPERIENCE)
            });
            dialogs.showModal($cd458192e783a00b$var$LazyUnarchivePagesLoader, {
                contentId: contentId,
                onPageRestore: statusRefetch,
                source: (0, $aqBZ0.ARCHIVED_PAGE_BANNER_ANALYTICS_SOURCE)
            });
        }, [
        contentId,
        createAnalyticsEvent,
        experienceTracker,
        statusRefetch
    ]);
    const fireLearnMoreEvent = (0, $42omo.useCallback)(()=>(0, $12UWa.fireUIClickEvent)({
            createAnalyticsEvent: createAnalyticsEvent,
            actionSubject: 'link',
            actionSubjectId: 'restoreLearnMore',
            source: (0, $aqBZ0.ARCHIVED_PAGE_BANNER_ANALYTICS_SOURCE)
        }), [
        createAnalyticsEvent
    ]);
    const noteDataContent = noteData?.content?.nodes?.[0];
    const userCanRestorePage = (0, $kpLJY.canRestoreContent)([
        ...noteDataContent?.operations || []
    ]);
    const archiveNote = noteDataContent?.archivedContentMetadata?.archiveNote || '';
    // accountId does not exist on Anonymous user type, so we need to use bracket notation to get the property or undefined
    const archiverAccountId = noteDataContent?.history?.lastUpdated?.by?.['accountId'];
    // Similar to the status data, if the user changes to a different page/content item, this
    // component will remain mounted and will fetch the data for the new page, but the old "noteData"
    // is still available while the new data is being fetched. So the new data isn't really ready
    // until we see that the data has the correct contentId in it.
    const isNoteDataAvailable = noteDataContent && noteDataContent?.id === contentId;
    // Only update the value; creating and assigning a whole new object will cause ExperienceSuccess's
    // useEffect() to think something has changed and it will fire the "success" event again.
    successAttributes.archivedPageBannerShown = isContentArchived;
    const isBannerRendered = isStatusDataAvailable && isContentArchived && !!noteDataContent;
    (0, $42omo.useEffect)(()=>{
        if (isBannerRendered) (0, $cbc8g.addUFOCustomData)({
            archivedPageBannerRendered: true
        });
    }, [
        isBannerRendered
    ]);
    const error = statusError || noteDataError;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $b3j2Y.ErrorDisplay), {
        error: error
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $gfIPU.ExperienceFailure), {
        name: (0, $irVI7.ARCHIVED_PAGE_BANNER_EXPERIENCE),
        error: error
    })), isStatusDataAvailable && (!isContentArchived || !!isNoteDataAvailable) && // Note that using a "key" prop with the "contentId" here will make React create a new
    // ExperienceSuccess instance, which is useful because we can remain mounted when the user
    // changes to a different content item
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $1eaCJ.ExperienceSuccess), {
        name: (0, $irVI7.ARCHIVED_PAGE_BANNER_EXPERIENCE),
        key: contentId,
        attributes: successAttributes
    }), isStatusDataAvailable && isContentArchived && noteDataContent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cd458192e783a00b$var$LazyArchivedPageBannerContent, {
        contentId: contentId,
        marginStyle: marginStyle,
        userCanRestorePage: userCanRestorePage,
        archiveNote: archiveNote,
        archiverAccountId: archiverAccountId,
        getUnarchiveDialogOpener: getUnarchiveDialogOpener,
        fireLearnMoreEvent: fireLearnMoreEvent
    }) : null);
};
const $cd458192e783a00b$export$a32ab742d345a2c9 = ({ contentId: contentId, marginStyle: marginStyle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $4PPzL.ErrorBoundary), {
        attribution: (0, $3IBnw.Attribution).ADMIN_EXPERIENCE
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $ln0hx.ExperienceStart), {
        name: (0, $irVI7.ARCHIVED_PAGE_BANNER_EXPERIENCE),
        key: contentId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($cd458192e783a00b$var$ArchivedPageBannerComponent, {
        contentId: contentId,
        marginStyle: marginStyle
    }));
module.exports["ArchivedPageBanner"] = $cd458192e783a00b$export$a32ab742d345a2c9;

});

parcelRegister("ccWUN", function(module, exports) {
/**
 * @generated SignedSource<<3bb251200fc6fbd0b59cca766c0c395f>>
 * @relayHash 3fac23e69ad72cef246c33b6b22b24bc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 977d9e099882e8a74d82099a73a8a2401956aa3722a387c1dad0080809f1647f
const $462dea7d21a073f6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "id",
            "variableName": "contentId"
        },
        {
            "kind": "Literal",
            "name": "status",
            "value": [
                "archived",
                "current"
            ]
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "type"
    }, v4 = {
        "concreteType": "OperationCheckResult",
        "kind": "LinkedField",
        "name": "operations",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "operation"
            },
            {
                "kind": "ScalarField",
                "name": "targetType"
            }
        ]
    }, v5 = {
        "concreteType": "ArchivedContentMetadata",
        "kind": "LinkedField",
        "name": "archivedContentMetadata",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "archiveNote"
            }
        ]
    }, v6 = [
        {
            "kind": "ScalarField",
            "name": "accountId"
        }
    ], v7 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "KnownUser"
    }, v8 = {
        "kind": "InlineFragment",
        "selections": v6 /*: any*/ ,
        "type": "UnknownUser"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ArchivedPageBannerV2ArchivedPageBannerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "lastUpdated",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ArchivedPageBannerV2ArchivedPageBannerQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "PaginatedContentListWithChild",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                {
                                    "concreteType": "History",
                                    "kind": "LinkedField",
                                    "name": "history",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "Version",
                                            "kind": "LinkedField",
                                            "name": "lastUpdated",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "by",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "__typename"
                                                        },
                                                        v7 /*: any*/ ,
                                                        v8 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "cacheID": "3fac23e69ad72cef246c33b6b22b24bc",
            "id": "977d9e099882e8a74d82099a73a8a2401956aa3722a387c1dad0080809f1647f",
            "metadata": {},
            "name": "ArchivedPageBannerV2ArchivedPageBannerQuery",
            "operationKind": "query",
            "text": "query ArchivedPageBannerV2ArchivedPageBannerQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\"]){nodes{id,type,operations{operation,targetType},archivedContentMetadata{archiveNote},history{lastUpdated{by{__typename,...on KnownUser{accountId},...on UnknownUser{accountId}}}}}}}"
        }
    };
}();
$462dea7d21a073f6$var$node.hash = "e569274206c06e3436e0c3de5c5fe595";
var $462dea7d21a073f6$export$2e2bcd8739ae039 = $462dea7d21a073f6$var$node;
module.exports["default"] = $462dea7d21a073f6$export$2e2bcd8739ae039;

});

parcelRegister("gFF2G", function(module, exports) {
/**
 * @generated SignedSource<<3c1858cbb3e477803479b53c1beabef7>>
 * @relayHash 30a7ec0bd1bc84739eda7e4fe244b93f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0842a0612fc51286d828e08036899cfa0544d19e34074003bb58229be73c3c8d
const $385b63e5393fb4b0$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Literal",
                    "name": "status",
                    "value": [
                        "archived",
                        "current"
                    ]
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "status"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "30a7ec0bd1bc84739eda7e4fe244b93f",
            "id": "0842a0612fc51286d828e08036899cfa0544d19e34074003bb58229be73c3c8d",
            "metadata": {},
            "name": "ArchivedPageBannerV2ArchivedPageBannerContainerQuery",
            "operationKind": "query",
            "text": "query ArchivedPageBannerV2ArchivedPageBannerContainerQuery($contentId:ID){content(id:$contentId,status:[\"archived\",\"current\"]){nodes{id,status}}}"
        }
    };
}();
$385b63e5393fb4b0$var$node.hash = "c639141edd782146ad296893dc79f146";
var $385b63e5393fb4b0$export$2e2bcd8739ae039 = $385b63e5393fb4b0$var$node;
module.exports["default"] = $385b63e5393fb4b0$export$2e2bcd8739ae039;

});

parcelRegister("gfIPU", function(module, exports) {

var $frIzR = parcelRequire("frIzR");


var $42omo = parcelRequire("42omo");


var $1kHsc = parcelRequire("1kHsc");

function $5675860ef242c9e4$export$eed1d73ebdd8c7ab(t0) {
    const $ = (0, $frIzR.c)(6);
    const { name: name, error: error, attributes: attributes } = t0;
    const experienceTracker = (0, $42omo.useContext)((0, $1kHsc.ExperienceTrackerContext));
    let t1;
    let t2;
    if ($[0] !== attributes || $[1] !== error || $[2] !== experienceTracker || $[3] !== name) {
        t1 = ()=>experienceTracker.fail({
                name: name,
                error: error,
                attributes: attributes
            });
        t2 = [
            experienceTracker,
            name,
            error,
            attributes
        ];
        $[0] = attributes;
        $[1] = error;
        $[2] = experienceTracker;
        $[3] = name;
        $[4] = t1;
        $[5] = t2;
    } else {
        t1 = $[4];
        t2 = $[5];
    }
    (0, $42omo.useEffect)(t1, t2);
    return null;
}
module.exports["ExperienceFailure"] = $5675860ef242c9e4$export$eed1d73ebdd8c7ab;

});

parcelRegister("kpLJY", function(module, exports) {

var $1ggpj = parcelRequire("1ggpj");

const $0a26534720307814$var$isValidContentType = (contentType)=>{
    if (!contentType) return false;
    return (0, $1ggpj.VALID_OPERATION_TARGETS).includes(contentType);
};
const $0a26534720307814$export$482055539d5cd058 = (operations)=>{
    if (operations) return operations.some((singleOperation)=>{
        return $0a26534720307814$var$isValidContentType(singleOperation?.targetType) && singleOperation?.operation === 'archive';
    });
    return false;
};
const $0a26534720307814$export$c1a3ac49d9650e25 = (operations)=>{
    if (operations) return operations.some((singleOperation)=>{
        return $0a26534720307814$var$isValidContentType(singleOperation?.targetType) && singleOperation?.operation === 'delete';
    });
    return false;
};
const $0a26534720307814$export$b70e008aef4dbd20 = (operations)=>$0a26534720307814$export$482055539d5cd058(operations);
const $0a26534720307814$export$45c8d206d1e3c1a5 = (operations)=>$0a26534720307814$export$482055539d5cd058(operations);
module.exports["canArchiveContent"] = $0a26534720307814$export$482055539d5cd058;
module.exports["canDeleteContent"] = $0a26534720307814$export$c1a3ac49d9650e25;
module.exports["canRestoreContent"] = $0a26534720307814$export$b70e008aef4dbd20;
module.exports["canEditContentArchiveNote"] = $0a26534720307814$export$45c8d206d1e3c1a5;

});

parcelRegister("12UWa", function(module, exports) {
const $d42c1236b5cc8ac8$export$d569af9d235186c9 = (isArchive, isBulk = false)=>isArchive ? isBulk ? 'bulkArchive' : 'archive' : isBulk ? 'bulkRestore' : 'restore';
const $d42c1236b5cc8ac8$export$a1562d08625f5d7e = 'sendUIEvent';
const $d42c1236b5cc8ac8$export$947dac6c72b26f81 = 'sendTrackEvent';
const $d42c1236b5cc8ac8$export$c2f50b86729b5b74 = 'selectDropdown';
const $d42c1236b5cc8ac8$export$fedfc172a3b39723 = 'spaceSelect';
const $d42c1236b5cc8ac8$export$79fc012ce0853550 = 'button';
const $d42c1236b5cc8ac8$export$7eca133280843f9e = (eventProps)=>$d42c1236b5cc8ac8$export$3e13615bb023ad8f({
        ...eventProps,
        type: $d42c1236b5cc8ac8$export$a1562d08625f5d7e
    });
const $d42c1236b5cc8ac8$export$5edee710fd3e881c = (eventProps)=>$d42c1236b5cc8ac8$export$7eca133280843f9e({
        ...eventProps,
        action: 'clicked'
    });
const $d42c1236b5cc8ac8$export$574d2f19a52d67ca = (eventProps)=>$d42c1236b5cc8ac8$export$3e13615bb023ad8f({
        ...eventProps,
        type: $d42c1236b5cc8ac8$export$947dac6c72b26f81
    });
const $d42c1236b5cc8ac8$export$59608e0169622110 = (eventProps)=>$d42c1236b5cc8ac8$export$3e13615bb023ad8f({
        ...eventProps,
        type: 'sendScreenEvent'
    });
const $d42c1236b5cc8ac8$export$3e13615bb023ad8f = (params)=>{
    const { createAnalyticsEvent: createAnalyticsEvent, type: type, ...data } = params;
    createAnalyticsEvent({
        type: type,
        data: data
    }).fire();
};
module.exports["getActionName"] = $d42c1236b5cc8ac8$export$d569af9d235186c9;
module.exports["fireUIClickEvent"] = $d42c1236b5cc8ac8$export$5edee710fd3e881c;
module.exports["fireTrackEvent"] = $d42c1236b5cc8ac8$export$574d2f19a52d67ca;
module.exports["fireScreenEvent"] = $d42c1236b5cc8ac8$export$59608e0169622110;

});

parcelRegister("8BLp4", function(module, exports) {

let $64468cc356a82dd3$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $64468cc356a82dd3$var$load("kHOMt"),
    $64468cc356a82dd3$var$load("ijAU0"),
    $64468cc356a82dd3$var$load("1WCMN"),
    $64468cc356a82dd3$var$load("2QTNW"),
    $64468cc356a82dd3$var$load("42aQC"),
    $64468cc356a82dd3$var$load("jyWy1"),
    $64468cc356a82dd3$var$load("7o5Pu"),
    $64468cc356a82dd3$var$load("9pso5"),
    $64468cc356a82dd3$var$load("hhss7"),
    $64468cc356a82dd3$var$load("8W6BK"),
    $64468cc356a82dd3$var$load("dxDVc")
]).then(()=>parcelRequire('ew61I'));

});

parcelRegister("VfvF4", function(module, exports) {

let $0ac15ae1fc14c926$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $0ac15ae1fc14c926$var$load("bWpNZ"),
    $0ac15ae1fc14c926$var$load("1lfwL")
]).then(()=>parcelRequire('932pg'));

});


//# sourceMappingURL=ArchivedPageBannerV2.e33b2443.js.map
